import type { ExternalSystem } from "@/lib/arch-parser";

const SLUG_BY_KEYWORD: { keyword: string; slug: string }[] = [
  { keyword: "amazon-web-services", slug: "amazonwebservices" },
  { keyword: "aws-lambda", slug: "awslambda" },
  { keyword: "amazon-s3", slug: "amazons3" },
  { keyword: "aws-s3", slug: "amazons3" },
  { keyword: "amazon-rds", slug: "amazonrds" },
  { keyword: "amazon-dynamodb", slug: "amazondynamodb" },
  { keyword: "amazon-sqs", slug: "amazonsqs" },
  { keyword: "amazon-sns", slug: "amazonsns" },
  { keyword: "cloudfront", slug: "amazoncloudfront" },
  { keyword: "amazon-ec2", slug: "amazonec2" },
  { keyword: "amazon", slug: "amazon" },
  { keyword: "aws", slug: "amazonwebservices" },
  { keyword: "s3", slug: "amazons3" },

  { keyword: "microsoft-azure", slug: "microsoftazure" },
  { keyword: "microsoft-graph", slug: "microsoft" },
  { keyword: "microsoft-purview", slug: "microsoft" },
  { keyword: "microsoft-sharepoint", slug: "microsoftsharepoint" },
  { keyword: "microsoft-teams", slug: "microsoftteams" },
  { keyword: "office-365", slug: "microsoftoffice" },
  { keyword: "ms-graph", slug: "microsoft" },
  { keyword: "ms-purview", slug: "microsoft" },
  { keyword: "sharepoint", slug: "microsoftsharepoint" },
  { keyword: "azure", slug: "microsoftazure" },
  { keyword: "microsoft", slug: "microsoft" },

  { keyword: "google-cloud", slug: "googlecloud" },
  { keyword: "gcp", slug: "googlecloud" },
  { keyword: "bigquery", slug: "googlebigquery" },
  { keyword: "google", slug: "google" },
  { keyword: "firebase", slug: "firebase" },

  { keyword: "stripe", slug: "stripe" },
  { keyword: "adyen", slug: "adyen" },
  { keyword: "paypal", slug: "paypal" },
  { keyword: "braintree", slug: "braintree" },

  { keyword: "sendgrid", slug: "twilio" },
  { keyword: "twilio", slug: "twilio" },
  { keyword: "mailgun", slug: "mailgun" },
  { keyword: "postmark", slug: "postmark" },

  { keyword: "salesforce", slug: "salesforce" },
  { keyword: "hubspot", slug: "hubspot" },
  { keyword: "intercom", slug: "intercom" },
  { keyword: "zendesk", slug: "zendesk" },

  { keyword: "github", slug: "github" },
  { keyword: "gitlab", slug: "gitlab" },
  { keyword: "bitbucket", slug: "bitbucket" },

  { keyword: "auth0", slug: "auth0" },
  { keyword: "okta", slug: "okta" },
  { keyword: "clerk", slug: "clerk" },
  { keyword: "supabase", slug: "supabase" },

  { keyword: "cloudflare", slug: "cloudflare" },
  { keyword: "datadog", slug: "datadog" },
  { keyword: "sentry", slug: "sentry" },
  { keyword: "new-relic", slug: "newrelic" },

  { keyword: "snowflake", slug: "snowflake" },
  { keyword: "databricks", slug: "databricks" },
  { keyword: "postgres", slug: "postgresql" },
  { keyword: "postgresql", slug: "postgresql" },
  { keyword: "mysql", slug: "mysql" },
  { keyword: "mongodb", slug: "mongodb" },
  { keyword: "redis", slug: "redis" },
  { keyword: "elasticsearch", slug: "elasticsearch" },
  { keyword: "kafka", slug: "apachekafka" },
  { keyword: "rabbitmq", slug: "rabbitmq" },

  { keyword: "openai", slug: "openai" },
  { keyword: "anthropic", slug: "anthropic" },
  { keyword: "claude", slug: "anthropic" },

  { keyword: "slack", slug: "slack" },
  { keyword: "discord", slug: "discord" },
  { keyword: "linear", slug: "linear" },
  { keyword: "notion", slug: "notion" },
  { keyword: "asana", slug: "asana" },
  { keyword: "jira", slug: "jira" },
  { keyword: "atlassian", slug: "atlassian" },

  { keyword: "shopify", slug: "shopify" },
  { keyword: "wix", slug: "wix" },
  { keyword: "contentful", slug: "contentful" },
  { keyword: "sanity", slug: "sanity" },
];

export function brandIconSlug(system: ExternalSystem): string | null {
  const haystacks = [
    system.id.toLowerCase(),
    system.label.toLowerCase(),
    (system.type ?? "").toLowerCase(),
  ];
  for (const { keyword, slug } of SLUG_BY_KEYWORD) {
    for (const hay of haystacks) {
      if (hay.includes(keyword)) return slug;
    }
  }
  return null;
}

export function brandIconSlugFromName(name: string): string | null {
  const hay = name.toLowerCase();
  for (const { keyword, slug } of SLUG_BY_KEYWORD) {
    if (hay.includes(keyword)) return slug;
  }
  return null;
}

export function brandIconUrl(slug: string): string {
  return `https://cdn.simpleicons.org/${encodeURIComponent(slug)}`;
}
